import { Component, Input, OnInit } from "@angular/core";
import { faWrench } from "@fortawesome/free-solid-svg-icons";
import { TranslateService } from "@ngx-translate/core";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Tool } from "src/app/models/Tool";

import { AuthService } from "../../services/auth.service";
import { NotifierService } from "../../services/notifier.service";
import { RaBasketService } from "../../services/ra-basket.service";
import { ToolService } from "../../services/tool.service";

@Component({
  selector: "service-request-button",
  templateUrl: "./service-request-button.component.html",
  styleUrls: ["./service-request-button.component.scss"],
  standalone: false,
})
export class ServiceRequestButtonComponent implements OnInit {
  faWrench = faWrench;
  @Input() tool: Tool;

  constructor(
    private basket: RaBasketService,
    public toolService: ToolService,
    public authService: AuthService,
    private notifierService: NotifierService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.tool.addedToRA = this.basket.isToolAlreadyInBasket(this.tool);
  }

  async updateItemAsync() {
    if (!this.tool.addedToRA) {
      this.basket.add(this.tool);

      const translation = await this.translateService
        .get(LocalizationConstants.BASKET_ITEM_SERVICE_REQUEST_ADDED_MESSAGE)
        .toPromise();

      this.notifierService.showNotification(
        this.tool.serialNumber,
        translation,
        "",
        RouteNameConstants.SERVICE_REQUEST,
      );
    } else {
      this.basket.remove(this.tool);

      const translation = await this.translateService
        .get(LocalizationConstants.BASKET_ITEM_SERVICE_REQUEST_REMOVED_MESSAGE)
        .toPromise();

      this.notifierService.showNotification(
        this.tool.serialNumber,
        translation,
        "",
        RouteNameConstants.SERVICE_REQUEST,
      );
    }

    this.tool.addedToRA = !this.tool.addedToRA;
  }
}
